interface Entry {
	label: string
	value: string
	id: string
}

function entry(label: string, id: string, value = label): Entry {
	return {label, value, id}
}

const BUSINESS_TYPES = [
	entry(
		'Agricultural Merchant / Farm Store',
		'agricultural_merchant_farm_store'
	),
	entry('Animal Shelter / Charity', 'animal_shelter_charity'),
	entry('Backgrounder Lot', 'backgrounder_lot'),
	entry('Beef Producer', 'beef_producer'),
	entry('Broilers', 'broilers'),
	entry('Buying Group', 'buying_group'),
	entry('Calf Production', 'calf_production'),
	entry(
		'Beef Calf Ranch/Developer',
		'beef_calf_ranch_developer',
		'Beef Calf - Ranch / Developer'
	),
	entry('Cattle Buyer', 'cattle_buyer'),
	entry('Cooperative', 'cooperative', 'Co Operative'),
	entry('Corporate Office', 'corporate_office'),
	entry(
		'Beef Cow/Calf Operation',
		'beef_cow_calf_operation',
		'Beef - Cow / Calf Operation'
	),
	entry('Dairy Producer', 'dairy_producer', 'Dairy Producer'),
	entry('Distributor / Agent', 'distributor_agent', 'Distributor / Agent'),
	entry('Feed Mill', 'feed_mill'),
	entry('Beef Feedyard', 'beef_feedyard', 'Beef - Feedyard'),
	entry(
		'Beef Grower/Growyard',
		'beef_grower_growyard',
		'Beef - Grower / Growyard'
	),
	entry('Hatchery', 'hatchery'),
	entry(
		'Dairy Heifer Production',
		'dairy_heifer_production',
		'Dairy - Heifer Production'
	),
	entry('Layer Integration', 'layer_integration'),
	entry('Layers', 'layers'),
	entry('Media', 'media'),
	entry(
		'Dairy Milk Cooperative/Buyer',
		'dairy_milk_cooperative_buyer',
		'Dairy - Milk Cooperative / Buyer'
	),
	entry(
		'Mixed/Other Producer',
		'mixed_other_producer',
		'Mixed / Other Producer'
	),
	entry('Nutrient Supplier', 'nutrient_supplier'),
	entry('Packer/Processor', 'packer_processor', 'Packer / Processor'),
	entry(
		'Pet Retail Outlet',
		'pet_retail_outlet',
		'Pet Retail Outlet - Brick & Mortar'
	),
	entry('Pharmacy', 'pharmacy'),
	entry('Poultry Breeder', 'poultry_breeder'),
	entry('Poultry Integrator', 'poultry_integrator'),
	entry('Sheep Producer', 'sheep_producer'),
	entry('Stocker Operation', 'stocker_operation'),
	entry('Stockyard/Salebarn', 'stockyard_salebarn', 'Stockyard / Salebarn'),
	entry('Swine Producer', 'swine_producer'),
	entry('Turkeys', 'turkeys', 'Turkeys'),
	entry('University / Education', 'university_education'),
	entry('Veterinary Practice', 'veterinary_practice'),
	entry('Wholesaler / Retailer', 'wholesaler_retailer'),
	entry('Wool Buyer', 'wool_buyer'),
	entry('Cattle Grower/Growyard', 'cattle_grower_growyard'),
	entry('Calf Producer', 'calf_producer'),
	entry('Animal Health Advisory Services', 'animal_health_advisory_services'),
	entry('Calf Ranch / Developer', 'calf_ranch_developer'),
	entry('Beef - Stocker Operation', 'beef_stocker_operation'),
	entry('Heifer Production', 'heifer_production'),
	entry('Milk Cooperative / Buyer', 'milk_cooperative_buyer'),
	entry('Cow / Calf Operation', 'cow_calf_operation'),
	entry('Feedyard', 'feedyard'),
	entry('Dairy Production', 'dairy_production', 'Dairy Production'),
	entry('Grower / Growyard', 'grower_growyard'),
	entry('Distributor', 'distributor'),
	entry('Turkey Producer', 'turkey_producer', 'Turkey Producer'),
	entry('Contract Grower', 'contract_grower'),
]

const ROLES = [
	entry('Academic', 'academic'),
	entry('Animal Welfare - Other', 'animal_welfare_other'),
	entry('Animal Welfare - Retail Staff', 'animal_welfare_retail_staff'),
	entry('Animal Welfare - Vet', 'animal_welfare_vet'),
	entry('Animal Welfare - Vet Nurse', 'animal_welfare_vet_nurse'),
	entry('Animal Welfare - Volunteer', 'animal_welfare_volunteer'),
	entry('Beef / Feedlot Extension', 'beef_feedlot_extension'),
	entry('Beef Producer', 'beef_producer'),
	entry('Breeder', 'breeder'),
	entry(
		'Business Administrator / Receptionist',
		'business_administrator_receptionist'
	),
	entry('Business Owner / Partner', 'business_owner_partner'),
	entry('Consulting Nutritionist', 'consulting_nutritionist'),
	entry(
		'Corporate Veterinary Employee (non-hospital)',
		'corporate_employee_non_dvm',
		'Corporate Employee Non DVM'
	),
	entry('Dairy Producer', 'dairy_producer'),
	entry('Distributor', 'distributor'),
	entry('Distributor Rep, Field Based', 'distributor_rep_field_based'),
	entry('Distributor Rep, Inside', 'distributor_rep_inside'),
	entry(
		'Educational Institute - Highschool Student',
		'educational_institution_highschool_student',
		'Educational Institution - Highschool Student'
	),
	entry(
		'Educational Institute - TAFE Student',
		'educational_institution_tafe_student',
		'Educational Institution - TAFE Student'
	),
	entry(
		'Educational Institute - University Student',
		'educational_institution_university_student',
		'Educational Institution - University Student'
	),
	entry('Groomer', 'groomer'),
	entry(
		'Medical/Clinic Director',
		'medical_clinic_director',
		'Medical / Clinic Director'
	),
	entry('Nutrition / Feed Sales', 'nutrition_feed_sales'),
	entry('Nutritional Professional', 'nutritional_professional'),
	entry('Nutritionist', 'nutritionist'),
	entry(
		'Office/Practice Manager',
		'office_practice_manager',
		'Office / Practice Manager'
	),
	entry('OTC Retailer', 'otc_retailer'),
	entry('Pharmacist', 'pharmacist'),
	entry('Pharmacy - Staff', 'pharmacy_staff'),
	entry('Pig Producer', 'pig_producer'),
	entry('Poultry Producer', 'poultry_producer'),
	entry('Practice Owner, Non DVM', 'practice_owner_non_dvm'),
	entry('Producer - Mixed/Other', 'producer_mixed_other'),
	entry(
		'Receptionist/Client Service',
		'receptionist_client_service',
		'Receptionist / Client Service'
	),
	entry('Reseller Store - Staff', 'reseller_store_staff'),
	entry('RAMA / SQP', 'sqp', 'SQP'),
	entry('Retailer', 'retailer'),
	entry('Sheep Producer', 'sheep_producer'),
	entry('Student RAMA', 'student_rama'),
	entry('Student', 'student'),
	entry('Tierarzt/Tierärztin', 'tierarzt_tierarztin', 'Tierarzt/ Tierärztin'),
	entry('Trainer', 'trainer'),
	entry('Veterinarian', 'veterinarian'),
	entry('Veterinarian, Practice Owner', 'veterinarian_practice_owner'),
	entry('Veterinary Assistant', 'veterinary_assistant'),
	entry('Veterinary Nurse', 'veterinary_nurse'),
	entry('Veterinary Practice - Other', 'veterinary_practice_other'),
	entry('Veterinary Practice - Vet', 'veterinary_practice_vet'),
	entry('Veterinary Practice - Vet Nurse', 'veterinary_practice_vet_nurse'),
	entry('Veterinary Specialist', 'veterinary_specialist'),
	entry('Veterinary Student', 'veterinary_student'),
	entry('Veterinary Surgeon', 'veterinary_surgeon'),
	entry('Veterinary Technician', 'veterinary_technician'),
	entry('Wholesaler', 'wholesaler'),
]

const SALUTATIONS = [
	entry('Dr.', 'dr'),
	entry('M.', 'm'),
	entry('Miss', 'miss'),
	entry('Mr.', 'mr'),
	entry('Mrs.', 'mrs'),
	entry('Ms.', 'ms'),
	entry('Mx.', 'mx'),
	entry('Professor', 'professor'),
]

export {BUSINESS_TYPES, ROLES, SALUTATIONS}
